import React, { useRef } from 'react';
import useAppConfig from '../../components/utils/AppConfig/useAppConfig';
import { SocketClientContext } from './SocketClientContext';
import SocketService from './SocketService';
const SocketClientContextProvider = ({ children }) => {
    const appConfig = useAppConfig();
    const socketClient = useRef(new SocketService(appConfig.serviceUrlEdanaApiNotf)).current;
    return (<SocketClientContext.Provider value={{ socketClient }}>
      {children}
    </SocketClientContext.Provider>);
};
export default SocketClientContextProvider;
